<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  siteListMethod,
  batchListMethod,
  categoryListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Category',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      name: '',
      description: '',
      userError: null,
      isUserError: false,
      isLoading: false,
      show: false,
      platformId: null,
      platform: '',
      collegeId: '',
      collegeName: '',
      teacherList: [],
      teacherDataList: [],
      batchList: [],
      timeError: false,
      siteconfiglist: [],
    }
  },
  computed: {
    ...authComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getListOfPlatform()
    this.fetchSiteList()
      .then((siteconfig) => {
        siteconfig.forEach((element) => {
          if (
            element.platform_id === this.currentUser.user.platform_id &&
            this.role !== 'admin'
          ) {
            this.platformId = element.platform_id
            this.platform = element.site_name
            this.collegeId = element.platform_id
            this.collegeName = element.site_name
          }
        })
      })
      .catch((_error) => {})
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    ...batchListMethod,
    ...categoryListMethod,

    addCategoryData() {
      this.timeError = false
      this.isLoading = true
      const Data = {
        name: this.name,
        description: this.description,
        platform: this.platform,
        platform_id: this.platformId,
      }

      this.addCategory({ Data })
        .then((resp) => {
          this.isLoading = false
          this.$router.push({ name: 'category.list' })
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.userError = getError.message
          this.isUserError = true
          window.scrollTo(0, 0)
        })
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
    selectTeacher() {
      this.teacherList = []
      this.teacherId = null
      var i = 0
      this.teacherList.push({
        value: null,
        text: 'Select Teacher',
        disabled: true,
      })
      for (i = 0; i < this.teacherDataList.length; i++) {
        if (this.teacherDataList[i].batch === this.batchId) {
          this.teacherList.push({
            value: this.teacherDataList[i].value,
            text: this.teacherDataList[i].text,
          })
        }
      }
    },
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Platform',
            disabled: true,
          })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isUserError"
              variant="danger"
              v-html="userError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addCategoryData"
            >
              <b-form-group label="Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="name"
                  type="text"
                  placeholder="Enter Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Description*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="description"
                  type="text"
                  placeholder="Enter Description"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="role === 'admin'"
                label="Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                ></b-form-select>
              </b-form-group>
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/category-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
